import React from 'react';
import GamesIcon from 'assets/images/svg/Games.svg';

const ViewIcon = ({ className }: { className?: string }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M4.81922 1.92769C4.69141 1.92769 4.56883 1.97846 4.47845 2.06884C4.38807 2.15922 4.3373 2.2818 4.3373 2.40961V7.22883C4.3373 7.35665 4.38807 7.47923 4.47845 7.5696C4.56883 7.65998 4.69141 7.71076 4.81922 7.71076C4.94704 7.71076 5.06961 7.65998 5.15999 7.5696C5.25037 7.47923 5.30114 7.35665 5.30114 7.22883V2.40961C5.30114 2.2818 5.25037 2.15922 5.15999 2.06884C5.06961 1.97846 4.94704 1.92769 4.81922 1.92769ZM2.40961 4.81922C2.2818 4.81922 2.15922 4.87 2.06884 4.96037C1.97846 5.05075 1.92769 5.17333 1.92769 5.30114V7.22883C1.92769 7.35665 1.97846 7.47923 2.06884 7.5696C2.15922 7.65998 2.2818 7.71076 2.40961 7.71076C2.53742 7.71076 2.66 7.65998 2.75038 7.5696C2.84076 7.47923 2.89153 7.35665 2.89153 7.22883V5.30114C2.89153 5.17333 2.84076 5.05075 2.75038 4.96037C2.66 4.87 2.53742 4.81922 2.40961 4.81922ZM7.22883 3.85538C7.10102 3.85538 6.97844 3.90615 6.88806 3.99653C6.79768 4.08691 6.74691 4.20949 6.74691 4.3373V7.22883C6.74691 7.35665 6.79768 7.47923 6.88806 7.5696C6.97844 7.65998 7.10102 7.71076 7.22883 7.71076C7.35665 7.71076 7.47923 7.65998 7.5696 7.5696C7.65998 7.47923 7.71076 7.35665 7.71076 7.22883V4.3373C7.71076 4.20949 7.65998 4.08691 7.5696 3.99653C7.47923 3.90615 7.35665 3.85538 7.22883 3.85538ZM8.19268 0H1.44577C1.06233 0 0.694589 0.152321 0.423455 0.423455C0.152321 0.694589 0 1.06233 0 1.44577V8.19268C0 8.57612 0.152321 8.94386 0.423455 9.21499C0.694589 9.48612 1.06233 9.63844 1.44577 9.63844H8.19268C8.57612 9.63844 8.94386 9.48612 9.21499 9.21499C9.48612 8.94386 9.63844 8.57612 9.63844 8.19268V1.44577C9.63844 1.06233 9.48612 0.694589 9.21499 0.423455C8.94386 0.152321 8.57612 0 8.19268 0ZM8.6746 8.19268C8.6746 8.32049 8.62383 8.44307 8.53345 8.53345C8.44307 8.62383 8.32049 8.6746 8.19268 8.6746H1.44577C1.31795 8.6746 1.19537 8.62383 1.105 8.53345C1.01462 8.44307 0.963844 8.32049 0.963844 8.19268V1.44577C0.963844 1.31795 1.01462 1.19537 1.105 1.105C1.19537 1.01462 1.31795 0.963844 1.44577 0.963844H8.19268C8.32049 0.963844 8.44307 1.01462 8.53345 1.105C8.62383 1.19537 8.6746 1.31795 8.6746 1.44577V8.19268Z" fill="currentColor" />
  </svg>
);

interface MarketCardLayout6Props {
  colors: {
    background: string;
    text: string;
    button: string;
    buttonText: string;
    status: string;
    border: string;
  };
}

const MarketCardLayout6: React.FC<MarketCardLayout6Props> = ({ colors }) => {
  return (
    <div
      className="p-2 rounded-lg text-white"
      style={{
        background: colors.background,
        color: colors.text,
        border: `1px solid ${colors.border}`,
      }}
    >
      {/* Header: Icon, Title with View, and Result */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-1">
          {/* Games icon in light gray box */}
          <div className="w-8 h-8 bg-[#FFFFFF21] rounded-lg flex items-center justify-center">
            <img src={GamesIcon} alt="games" className="w-5 h-5" />
          </div>
          {/* Title with View */}
          <div className="flex items-center gap-1">
            <h3 className="font-semibold text-[12px] text-white">MAHADEVI</h3>
            <ViewIcon className="w-2 h-2 text-white" />
            <span className="text-[13px] text-white">View</span>
          </div>
        </div>
        {/* Result number in lighter gray box */}
        
        <div className="bg-[#FFFFFF0D] rounded-md px-1.5 py-1.5">
          <div className="text-base" style={{ color: colors.text }}>399-109-56</div>
        </div>
      </div>
      
      {/* Times with green highlights */}
      <div className="flex items-center justify-center gap-2">
        <div className="flex items-center gap-1">
          <span className="text-[9px]" style={{ color: colors.text }}>Open </span>
          <span className="font-semibold text-[10px]" style={{ color: colors.status }}>04:34 PM</span>
        </div>
        <div>
          <span className="text-[9px]" style={{ color: colors.text }}>Close </span>
          <span className="font-semibold text-[10px]" style={{ color: colors.status }}>04:34 PM</span>
        </div>
      </div>
      
      {/* Green gradient button at bottom */}
      <div
        className="w-full py-1.5 px-4 rounded-lg flex items-center justify-center gap-1"
        style={{ background: colors.button }}
      >
        <span className="text-[10px] leading-none font-medium" style={{ color: colors.buttonText }}>Betting is Open</span>
        <span className="leading-none" style={{ color: colors.buttonText, opacity: 0.8 }}>|</span>
        <span className="text-[14px] leading-none font-semibold" style={{ color: colors.buttonText }}>Place Bet</span>
      </div>
    </div>
  );
};

export default MarketCardLayout6;
